import { NextPageWithLayout } from '../../common/common-types'
import PageLayout from '../../components/page-layout/page-layout'
import retriveMessages, { LocaleType } from '../../messages/message'
import { GetStaticPaths, GetStaticPathsContext, GetStaticPropsContext } from 'next'
import { FC, PropsWithChildren, ReactElement, ReactNode, useEffect, useMemo, useState } from 'react'
import SectionOne from './section1'
import SectionTwo from './section2'
import SectionThree from './section3'
import SectionFour from './section4'
import SectionFive from './section5'
import SectionForm from './section-form'
import PdFloatRobot from '../../components/pd-float-robot/pd-float-robot'
import { withSEO } from '../../common/with-seo'

const TexasLandingPage: NextPageWithLayout = () => {
  return (
    <div className="texas-landing-page font-['Montserrat']">
      <div className="w-full mx-auto">
        {/* first section */}
        <SectionOne />

        {/* second section */}
        <SectionTwo />

        {/* third section */}
        <SectionThree />

        {/* fourth section */}
        <SectionFour />

        {/* fifth section */}
        <SectionFive />

        {/* form section */}
        <SectionForm />
      </div>

      <PdFloatRobot
        robot={'https://cdn.pudutech.com/website/images/landingpage-texas/bella_contactus.gif'}
        color="#fc7216"
        hideCircleBorder={true}
        href="#form"
      />
    </div>
  )
}

export const getStaticProps = withSEO(
  async ({ locale }: GetStaticPropsContext) => {
    const messages = retriveMessages(['successful-stories'], locale as LocaleType)
    return {
      props: {
        messages,
      },
      revalidate: 60,
    }
  },
  () => '/texas-bellabot'
)

TexasLandingPage.getLayout = function (page: ReactElement, seo) {
  return (
    <PageLayout
      sticky={true}
      bgWhite={true}
      pageTitle={'Food Running Trial'}
      pageDescription={'Food Running Trial'}
      pageKeywrods={'PUDU,BellaBot,Food Running Trial,USA,Texas'}
      ogtype={'website'}
    >
      {page}
    </PageLayout>
  )
}

export default TexasLandingPage
